export default function LoadingText({ text }) {
    return <h6>{text}</h6>
};